import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CameraIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    {/* Outer rounded rectangle */}
    <Path d="M21 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23H21C22.1046 23 23 22.1046 23 21V3C23 1.89543 22.1046 1 21 1Z" stroke={color} strokeWidth="2" />
    {/* Inner circle (lens) */}
    <Path d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z" stroke={color} strokeWidth="2" />
  </Svg>
);

CameraIcon.displayName = 'CameraIcon';
